import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'emotion-theming';
import moment from 'moment-timezone';
import { Backdrop } from '../../components/Themed.js';
import { getWaitingList } from '../../data/appointment/AppointmentActions.js';
import { getEmployeeName } from '../../data/employee/EmployeeReducer';
import { getIsServiceAvailableForClient } from '../../data/app/AppReducer.js';
import { translateToMins } from '../../common/utils.js';
import './Waitlist.css';
import { t } from '../../locales';

class Waitlist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTime: this.getCurrentTime(props.location),
    };

    this.refreshTime = this.refreshTime.bind(this);
    this.refreshWaitTime = this.refreshWaitTime.bind(this);
  }

  componentDidMount() {
    this.props.getWaitingList(this.props.location.id);
    this.intervalClock = setInterval(this.refreshTime, 1000);
    this.interval = setInterval(this.refreshWaitTime, 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalClock);
    clearInterval(this.interval);
  }

  getCurrentTime(location) {
    const { time_zone } = location;
    return moment.tz(new Date(), time_zone).format('h:mm A');
  }

  refreshTime() {
    this.setState({ currentTime: this.getCurrentTime(this.props.location) });
  }

  refreshWaitTime() {
    this.props.getWaitingList(this.props.location.id);
  }

  render() {
    const {
      waitList,
      employees,
      serviceProviderTerm,
      isLoadingWaitList,
      isServiceAvailableForClient,
      theme,
    } = this.props;

    let waitListWithEmployeeNames = [];
    if (employees.length > 0) {
      waitListWithEmployeeNames = waitList.map(i => ({
        ...i,
        employeeName: i.chosen_time
          ? getEmployeeName(i.chosen_time.employee_id, employees)
          : t('waitlist.next_available'),
        remainingTime: i.start_time_passed
          ? +t('staff_selection.n_a')
          : translateToMins(i.remaining_time * 1000, 'm', 'h'),
        isTurn: i.remaining_time < 60,
      }));
    }

    const emptyItemsCount =
      waitListWithEmployeeNames.length < 7
        ? 7 - waitListWithEmployeeNames.length
        : 0;

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="content-wide">
              <div className="time">
                {t('waitlist.current_time')} :{' '}
                <span className="clock">{this.state.currentTime}</span>
              </div>
              <div className="table">
                <div
                  className="header"
                  style={{
                    background: this.props.theme.themeColor,
                    color: 'rgb(255, 255, 255)',
                  }}
                >
                  <div className="col-header name">
                    {t('waitlist.customer_name')}
                  </div>
                  <div className="col-header employee">
                    {serviceProviderTerm}
                  </div>
                  <div className="col-header est">
                    {t('waitlist.est_wait_time')}
                  </div>
                </div>
                {waitListWithEmployeeNames.map(i => (
                  <div
                    className="item"
                    key={i.id}
                    style={{
                      fontWeight: i.isTurn ? 'bold' : null,
                      color: i.isTurn ? theme.themeColor : null,
                    }}
                  >
                    <div className="col name">
                      {i.child_label
                        ? (!isServiceAvailableForClient
                            ? i.client_name + ' - '
                            : '') + i.child_label
                        : i.client_name}
                    </div>
                    <div className="col employee">{i.employeeName}</div>
                    <div className="col est">
                      <span>
                        {i.isTurn ? t('waitlist.your_turn') : i.remainingTime}
                      </span>
                    </div>
                  </div>
                ))}
                {Array(emptyItemsCount)
                  .fill()
                  .map((a, i) => (
                    <div key={i} className="item empty-item" />
                  ))}
              </div>
              {isLoadingWaitList && (
                <i className="fas fa-spinner fa-pulse waitlist-spinner" />
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    location: state.app.location,
    waitList: state.appointment.waitList,
    isLoadingWaitList: state.appointment.isLoadingWaitList,
    employees: state.employee.employees,
    serviceProviderTerm: state.app.serviceProviderTerm,
    isServiceAvailableForClient: getIsServiceAvailableForClient(
      state.app.businessInfo
    ),
  };
}

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      { getWaitingList }
    )(Waitlist)
  )
);
